module.exports = {
          srcSet: __webpack_public_path__ + "images/2014-13aa59374492df30f1da1ec9a9717766-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2014-d47fe658b4830f2408a00cc0a70229bf-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2014-13aa59374492df30f1da1ec9a9717766-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2014-d47fe658b4830f2408a00cc0a70229bf-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2014-13aa59374492df30f1da1ec9a9717766-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2014-13aa59374492df30f1da1ec9a9717766-320.jpg"},
          
          width: 320,
          height: 251
        }